module.exports = __webpack_public_path__ + "static/img/lqb_bg.7973acc3.png";